module.exports = __webpack_public_path__ + "static/img/avatar.c4c40b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.jpg
// module id = lS+k
// module chunks = 1